import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const CardText = ({ header = "N/A", subHeader }) => {
	return (
		<Box>
			<Typography
				variant="body2"
				sx={{
					color: "#718096",
					textTransform: "uppercase",
					fontWeight: 500,
				}}
				gutterBottom
			>
				{header || "N/A"}
			</Typography>
			<Typography
				variant="body2"
				sx={{
					color: "#718096",
					textTransform: "capitalize",
					fontWeight: 400,
				}}
				gutterBottom
			>
				{subHeader}
			</Typography>
		</Box>
	);
};

export default CardText;
